export const keepOneObjectAndRemoveBooleans = (array) => {
  return array.filter(item => typeof item === 'object' && !Array.isArray(item));
};
